module.exports = __webpack_public_path__ + "img/asmah.9e5e8c57.jpg";